import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './app';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('#root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
